/**
 * Shared shell for the six flow-editor node types. Each kind gets a
 * distinct accent color + label prefix; the body renders data fields
 * passed in by the specific node component.
 */

import { Handle, Position } from '@xyflow/react';
import type { ReactNode } from 'react';

export interface NodeShellProps {
  title: string;
  kind: string;
  accent: string;
  selected?: boolean;
  children?: ReactNode;
}

export function NodeShell({ title, kind, accent, selected, children }: NodeShellProps) {
  return (
    <div
      style={{
        minWidth: 180,
        maxWidth: 260,
        background: '#fff',
        border: `2px solid ${selected ? 'var(--xp-selection)' : accent}`,
        borderRadius: 2,
        boxShadow: '1px 1px 0 #00000022',
        fontFamily: "var(--xp-font-body), sans-serif",
        fontSize: 11,
        color: '#000',
      }}
    >
      <Handle
        type="target"
        position={Position.Left}
        style={{ background: accent, width: 8, height: 8 }}
      />
      <div
        style={{
          background: accent,
          color: '#fff',
          padding: '2px 6px',
          fontWeight: 'bold',
          fontSize: 10,
          textTransform: 'uppercase',
          letterSpacing: 0.5,
        }}
      >
        {kind}
      </div>
      <div style={{ padding: '4px 6px', fontWeight: 'bold', borderBottom: '1px solid #eee' }}>
        {title}
      </div>
      {children !== undefined && <div style={{ padding: '4px 6px' }}>{children}</div>}
      <Handle
        type="source"
        position={Position.Right}
        style={{ background: accent, width: 8, height: 8 }}
      />
    </div>
  );
}
